import "./ResponsiveIframesInBlog.scss"

class ResponsiveIframesInBlog {
    constructor(targetNode = document.body) {
        this.targetNode = targetNode;
        this.init();
    }

    init() {
        console.log("DOM vollständig geladen, Initialisierung beginnt");

        this.observeMutations();
        this.processExistingIframes();

        console.log("MutationObserver eingerichtet");
    }

    wrapIframe(iframe) {
        var wrapper = document.createElement('div');
        wrapper.className = 'responsive-iframe';
        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
        console.log("Wrapper hinzugefügt:", wrapper);
    }

    adjustIframe(iframe) {
        console.log("Anpassen des iFrames:", iframe);
        var width = iframe.getAttribute('width');
        var height = iframe.getAttribute('height');

        if (width && height) {
            // Wrapper hinzufügen, falls nicht vorhanden
            if (!iframe.parentElement.classList.contains('responsive-iframe')) {
                this.wrapIframe(iframe);
            }

            var ratio = (height / width) * 100;
            var parentDiv = iframe.parentElement;

            if (parentDiv) {
                parentDiv.style.paddingBottom = ratio + '%';
                console.log("Wrapper angepasst mit Seitenverhältnis:", ratio + '%');
            }
        } else {
            console.log("Breite oder Höhe nicht definiert für:", iframe);
        }
    }

    handleAddedNode(node) {
        if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
            this.adjustIframe(node);
        } else if (node.tagName && node.tagName.toLowerCase() === 'p') {
            var iframe = node.querySelector('iframe');
            if (iframe) {
                this.adjustIframe(iframe);
            }
        } else if (node.querySelectorAll) {
            var nestedIframes = node.querySelectorAll('iframe');
            if (nestedIframes.length > 0) {
                nestedIframes.forEach(iframe => this.adjustIframe(iframe));
            }
        }
    }

    observeMutations() {
        var observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                console.log("Mutation erkannt:", mutation);
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        this.handleAddedNode(node);
                    });
                }
            });
        });

        observer.observe(this.targetNode, {
            childList: true,
            subtree: true
        });
    }

    processExistingIframes() {
        var existingIframes = this.targetNode.querySelectorAll('iframe');
        console.log("Gefundene iFrames beim Laden:", existingIframes);
        existingIframes.forEach(iframe => this.adjustIframe(iframe));
    }
}

// Initialisierung der Klasse
export { ResponsiveIframesInBlog }
